import classNames from 'classnames/bind';
import React, { useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import styles from './common.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import { FieldNumber } from '@/components/ui/kit/Field';

const cx = classNames.bind(styles);

const Command = ({ index, data: command }) => {
  const dispatch = useDispatch();
  const domRefs = useRef({
    relay: useRef(),
    count: useRef(),
    time: useRef(),
  }).current;

  useEffect(() => {
    domRefs.relay.current.value = command.data.relay;
    domRefs.count.current.value = command.data.count;
    domRefs.time.current.value = command.data.time;
  }, [command.data]);

  const handleBlur = (e) => {
    const name = e.target.name;
    let value = Math.trunc(e.target.value);

    switch (name) {
      case 'relay':
      case 'time':
        value = Math.max(0, value);
        break;
      case 'count':
        value = Math.max(1, value);
        break;
      default:
        break;
    }

    dispatch(actions.mission.updateCommand(index, name, value));
  };

  return (
    <div className={cx('container')}>
      <FieldRow label="Relay Instance Number">
        <FieldNumber ref={domRefs.relay} name="relay" onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Cycle Count">
        <FieldNumber ref={domRefs.count} name="count" onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Cycle Time" unit="secs">
        <FieldNumber ref={domRefs.time} name="time" onBlur={handleBlur} />
      </FieldRow>
    </div>
  );
};

export default Command;
